/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "name": "店招",
        "type": "module-name"
    },
    {
        "key": "style_type",
        "name": "样式",
        "type": "shop-header",
        "width": 270,
        "radio-list": [{
            "url": "https://img.mockuai.com/tms/2018/1/10/upload_480c994ab311be67823b31b3f2cf9c78.png",
            "value": 1
        }, {
            "url": "https://img.mockuai.com/tms/2018/1/10/upload_820740b9e69127d1c50fb53c6d67117c.png",
            "value": 2
        }, {
            "url": "https://img.mockuai.com/tms/2018/1/10/upload_313dcb5871f30f32e5b1edf63b357765.png",
            "value": 3
        }, {
            "url": "https://img.mockuai.com/tms/2018/1/10/upload_d65cef8cc6587bc00e8a83b10fc83496.png",
            "value": 4
        }]
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
            "key": "name",
            "name": "名称",
            "type": "text",
            "memo": "名称最多20个字",
            "max": 20
        }],
    }
];

export default config